import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconError } from "../../foundations/Iconography/IconError";
import * as styles from "./Feedback.styles";
export var Feedback = function Feedback(_ref) {
  var error = _ref.error,
    align = _ref.iconAlign,
    id = _ref.id,
    name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!name && /*#__PURE__*/React.createElement(_StyledSpan, {
    "data-has-error": !!error,
    id: id,
    $_css: styles.feedbackName
  }, /*#__PURE__*/React.createElement(_StyledSpan2, {
    "data-icon-align": align,
    $_css2: styles.errorField
  }, name, align === 'left' && /*#__PURE__*/React.createElement(_StyledIconError, {
    height: 16,
    width: 16,
    $_css3: styles.errorIconLeft
  }))), /*#__PURE__*/React.createElement(_StyledSpan3, {
    "data-has-error": !!error,
    $_css4: styles.feedbackValue
  }, /*#__PURE__*/React.createElement(_StyledSpan4, {
    "data-icon-align": align,
    $_css5: styles.errorField
  }, value, align === 'right' && /*#__PURE__*/React.createElement(_StyledIconError2, {
    height: 16,
    width: 16,
    $_css6: styles.errorIconRight
  }))));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan2 = _styled2("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconError = _styled3(IconError)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledSpan3 = _styled4("span")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledSpan4 = _styled5("span")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledIconError2 = /*#__PURE__*/_styled6(IconError).withConfig({
  displayName: "Feedback___StyledIconError2",
  componentId: "sc-1ifdode-0"
})(["", ""], function (p) {
  return p.$_css6;
});